import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ANGEL LEAGUE Factory ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Factory 더보러 가기 ")

import {computed} from 'vue'
import {AgBoxS, AgIconS} from '@/components/ag'
import NftFactoryItem from './NftFactoryItem.vue'
import nftFactoryPng from './assets/nft-factory.png'
import openSeaPng from './assets/open-sea.png'
import {useQuery} from '@vue/apollo-composable'
import {gql} from 'graphql-tag'
import {fromWei} from 'web3-utils'
import {useInAppBrowser, provideTrackPayload} from '@/composables'
import SeeMore from '../SeeMore.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

provideTrackPayload({
  clickArea: '팩토리',
})

const inAppBrowser = useInAppBrowser(' https://opensea.io/collection/angel-league-factory-klaytn ', '_black', {presentationStyle: 'fullscreen', toolbar: true})

const {result} = useQuery(gql`
    query {
      factories: items (
         collectionName: "factory", perPage: 4, randomFlag: true
      ) {
        id,
        title,
        imageUrl
        collection {
          chain
        }
        quantity
        detailUri
      }
    }
`)

const onOpenSite = () => {
  inAppBrowser.open()
}

const onVisitLink = (url: string) => {
  inAppBrowser.open(url)
}

const list = computed(() => {
  return (result.value?.factories ?? []).map((item: any) => {
    const {collection: {chain} = {} as any, id, imageUrl, quantity, detailUri, title} = item ?? {}
    return {
      chainKind: chain,
      chainQuantity: fromWei(quantity),
      id,
      imgSrc: imageUrl,
      link: detailUri,
      title,
    }
  })
})


return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return (_openBlock(), _createBlock(_unref(AgBoxS), null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_unref(AgBoxS), {
        css: {dp: 'flex', direction: 'row', alignItems: 'center', cursor: 'pointer'},
        onClick: onOpenSite
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: _unref(nftFactoryPng),
            css: {width: 32, height: 32, mr: 8}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h7', fontWeight: 'bold', mr: 8} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: _unref(openSeaPng),
            css: {width: 16, height: 16, mr: 8}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgIconS), {
            name: "chevronForward",
            css: {width: 16, height: 16, mr: 8, color: 'gray2'}
          })
        ]),
        _: 1
      }, 512), [
        [_directive_track, {clickContent: '팩토리로 링크'}]
      ]),
      _createVNode(_unref(AgBoxS), { css: {dp: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', py: 16} }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
            return (_openBlock(), _createBlock(NftFactoryItem, _mergeProps({
              key: item.id
            }, item, { onVisitLink: onVisitLink }), null, 16))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SeeMore, { onClick: onOpenSite }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 512), [
            [_directive_track, {clickContent: '더보기'}]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})